/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import AddPropertyStep1 from './AddPropertyStep1'
import AddPropertyStep2 from './AddPropertyStep2'
import AddPropertyStep3 from './AddPropertyStep3'
import AddPropertyStep4 from './AddPropertyStep4'
import AddPropertyStep5 from './AddPropertyStep5'
import AddPropertyStep6 from './AddPropertyStep6'
import {useFormik} from 'formik'
import {Create_New_Property} from './Property_Api'
import Swal from 'sweetalert2'
import {addPropertyPropsDataType} from './PropertyDataTypes'
import {AddPropertyInitialValues} from './PropertyInitialValues'
import {AddPropertyValidationSchema} from './PropertyValidationSchema'

const modalsRoot = document.getElementById('root-modals') || document.body

const AddNewNewProperty = ({
  show,
  handleClose,
  getProperty,
  activeKYC,
}: addPropertyPropsDataType) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  // function to go to previous step in add property modal
  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
  }

  // function to go to previous step in add property modal
  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkAddPropertyStep1()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!checkAddPropertyStep2()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkAddPropertyStep3()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 4) {
      if (!checkAddPropertyStep4()) {
        return
      }
    }
    if (stepper.current.getCurrentStepIndex() === 5) {
      if (!checkAddPropertyStep5()) {
        return
      }
    }
    stepper.current.goNext()
  }

  // formik values for add property form
  const formik = useFormik({
    initialValues: AddPropertyInitialValues,
    validationSchema: AddPropertyValidationSchema,
    onSubmit: () => createProperty(),
  })

  // submit function for add property form
  async function createProperty() {
    setSubmitBtnLoading(true)
    try {
      const {data: res} = await Create_New_Property(
        formik.values.property_type_uuid,
        formik.values.property_title,
        formik.values.carpet_area,
        formik.values.carpet_area_unit_uuid,
        formik.values.address_1,
        formik.values.address_2,
        parseInt(formik.values.country_id, 10),
        parseInt(formik.values.province_id, 10),
        formik.values.city,
        parseInt(formik.values.pin_zip, 10),
        parseInt(formik.values.current_rent, 10),
        formik.values.account_kyc_uuid,
        formik.values.isAgent === 'true' ? true : false,
        formik.values.owner_name,
        formik.values.owner_email_id,
        formik.values.owner_contact_number,
        formik.values.sub_unit_available === 'true' ? true : false,
        parseInt(formik.values.property_usage_type, 10),
        parseInt(formik.values.property_furnishing_status, 10),
        []
      )
      if (res.code === '200') {
        getProperty()
        handleClose()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
        allowOutsideClick: true,
      })
    } finally {
      setSubmitBtnLoading(false)
    }
  }

  // function to go to steps onclick of stepper headings
  const handleGoto = (val: number) => {
    let valid: number = 0
    if (val >= 1) {
      if (!checkAddPropertyStep1()) {
        stepper?.current?.goto(1)
        checkAddPropertyStep1()
        return
      } else if (val === 1 && valid === 0) {
        stepper?.current?.goto(1)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 2) {
      if (!checkAddPropertyStep2()) {
        stepper?.current?.goto(2)
        checkAddPropertyStep2()
        return
      } else if (val === 2 && valid === 1) {
        stepper?.current?.goto(2)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 3) {
      if (!checkAddPropertyStep3()) {
        stepper?.current?.goto(3)
        checkAddPropertyStep3()
        return
      } else if (val === 3 && valid === 2) {
        stepper?.current?.goto(3)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 4) {
      if (!checkAddPropertyStep4()) {
        stepper?.current?.goto(4)
        checkAddPropertyStep4()
        return
      } else if (val === 4 && valid === 3) {
        stepper?.current?.goto(4)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val >= 5) {
      if (!checkAddPropertyStep5()) {
        stepper?.current?.goto(5)
        checkAddPropertyStep5()
        return
      } else if (val === 5 && valid === 4) {
        stepper?.current?.goto(5)
        return
      } else {
        valid = valid + 1
      }
    }
    if (val === 6) {
      if (valid === 5) {
        stepper?.current?.goto(6)
        return
      }
    }
    return
  }

  // function to check step1 validations
  const checkAddPropertyStep1 = () => {
    if (
      formik.values.property_type_uuid &&
      formik.values.property_title &&
      formik.values.carpet_area &&
      formik.values.carpet_area_unit_uuid &&
      !formik.errors.property_type_uuid &&
      !formik.errors.property_title &&
      !formik.errors.carpet_area &&
      !formik.errors.carpet_area_unit_uuid
    ) {
      return true
    } else {
      formik.setTouched(
        {
          property_type_uuid: true,
          property_title: true,
          carpet_area: true,
          carpet_area_unit_uuid: true,
        },
        true
      )
      return false
    }
  }
  // function to check step2 validations
  const checkAddPropertyStep2 = () => {
    if (
      formik.values.address_1 &&
      formik.values.country_id &&
      formik.values.province_id &&
      formik.values.city &&
      formik.values.pin_zip &&
      !formik.errors.address_1 &&
      !formik.errors.address_2 &&
      !formik.errors.country_id &&
      !formik.errors.province_id &&
      !formik.errors.city &&
      !formik.errors.pin_zip
    ) {
      return true
    } else {
      formik.setTouched(
        {
          address_1: true,
          address_2: true,
          country_id: true,
          province_id: true,
          city: true,
          pin_zip: true,
        },
        true
      )
      return false
    }
  }
  // function to check step3 validations
  const checkAddPropertyStep3 = () => {
    if (
      formik.values.current_rent &&
      // formik.values.account_kyc_uuid &&
      !formik.errors.current_rent &&
      !formik.errors.account_kyc_uuid
    ) {
      return true
    } else {
      formik.setTouched(
        {
          current_rent: true,
          account_kyc_uuid: true,
        },
        true
      )
      return false
    }
  }
  // function to check step3 validations
  const checkAddPropertyStep4 = () => {
    if (
      formik.values.property_furnishing_status &&
      formik.values.property_usage_type &&
      formik.values.sub_unit_available &&
      !formik.errors.property_furnishing_status &&
      !formik.errors.property_usage_type &&
      !formik.errors.sub_unit_available
    ) {
      return true
    } else {
      formik.setTouched(
        {
          property_furnishing_status: true,
          property_usage_type: true,
          sub_unit_available: true,
        },
        true
      )
      return false
    }
  }
  // function to check step4 validations
  const checkAddPropertyStep5 = () => {
    if (formik.values.isAgent === 'true' && !formik.errors.isAgent) {
      if (
        formik.values.isAgent &&
        formik.values.owner_name &&
        formik.values.owner_email_id &&
        formik.values.owner_contact_number &&
        !formik.errors.owner_name &&
        !formik.errors.owner_email_id &&
        !formik.errors.owner_contact_number
      ) {
        return true
      } else {
        formik.setTouched(
          {
            isAgent: true,
            owner_name: true,
            owner_email_id: true,
            owner_contact_number: true,
          },
          true
        )
        return false
      }
    } else if (!formik.errors.isAgent) {
      return true
    } else {
      formik.setTouched(
        {
          isAgent: true,
          owner_name: true,
          owner_email_id: true,
          owner_contact_number: true,
        },
        true
      )
      return false
    }
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      {/* Begin: Modal header */}
      <div className='modal-header pt-5 pb-5'>
        {/* Begin: Modal Heading */}
        <h2>Add Property</h2>
        {/* End: Modal Heading */}
        {/* Begin::Close button */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close button */}
      </div>
      {/* End: Modal header */}

      {/* Begin: Modal body */}
      <div className='modal-body p-5'>
        {/*Begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          {/* Begin::Aside steps headings*/}
          <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
            {/* Begin::Nav*/}
            <div className='stepper-nav ps-lg-10'>
              {/* Begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(1)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>
                  {/* end::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Property Basics</h3>

                    <div className='stepper-desc'>Enter property details</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* Begin::Line*/}
                <div className='stepper-line h-35px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 1*/}

              {/* Begin::Step 2*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(2)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>
                  {/* Begin::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Address</h3>

                    <div className='stepper-desc'>Enter property address</div>
                  </div>
                  {/* Begin::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* Begin::Line*/}
                <div className='stepper-line h-35px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 2*/}
              {/* Begin::Step 3*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(3)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>
                  {/* Begin::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Rent and KYC Details</h3>

                    <div className='stepper-desc'>Enter Rent and KYC Details</div>
                  </div>
                  {/* Begin::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* Begin::Line*/}
                <div className='stepper-line h-35px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 3*/}

              {/* Begin::Step 4*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(4)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>4</span>
                  </div>
                  {/* end::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Category</h3>

                    <div className='stepper-desc'>Enter property category</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* Begin::Line*/}
                <div className='stepper-line h-35px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 4*/}

              {/* Begin::Step 5*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(5)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>5</span>
                  </div>
                  {/* end::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Owner/Agent Details</h3>

                    <div className='stepper-desc'>Provide owner/agent details</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* Begin::Line*/}
                <div className='stepper-line h-35px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 5*/}

              {/* Begin::Step 6*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* Begin::Wrapper*/}
                <div className='stepper-wrapper cursor-pointer' onClick={() => handleGoto(6)}>
                  {/* Begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>6</span>
                  </div>
                  {/* end::Icon*/}

                  {/* Begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>Review</h3>

                    <div className='stepper-desc'>Review and Submit</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}
              </div>
              {/* end::Step 6*/}
            </div>
            {/* end::Nav*/}
          </div>
          {/* Begin::Aside steps headings*/}

          {/*Begin:: Form Content */}
          <div className='flex-row-fluid px-lg-15'>
            {/*Begin::Form */}
            <form onSubmit={formik.handleSubmit} id='kt_modal_create_app_form'>
              <AddPropertyStep1 formik={formik} />
              <AddPropertyStep2 formik={formik} />
              <AddPropertyStep3 formik={formik} activeKYC={activeKYC} />
              <AddPropertyStep4 formik={formik} />
              <AddPropertyStep5 formik={formik} />
              <AddPropertyStep6 />
              {/*Begin::Actions */}
              <div className='d-flex flex-stack pt-4'>
                {/* Begin:: previous button div */}
                <div className='me-2'>
                  {/* Begin:: previous button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  {/* End:: previous button */}
                </div>
                {/* End:: previous button div */}
                {/* Begin:: Submit and next button div */}
                <div>
                  {/* Begin:: submit button */}
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='submit'
                    disabled={submitBtnLoading}
                  >
                    {submitBtnLoading ? (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Processing...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      'Submit'
                    )}
                  </button>
                  {/* Begin:: submit button */}

                  {/* Begin:: next button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    Next Step
                  </button>
                  {/* Begin:: next button */}
                </div>
                {/* Begin:: Submit and next button div */}
              </div>
              {/*end::Actions */}
            </form>
            {/*end::Form */}
          </div>
          {/*end:: Form Content */}
        </div>
        {/* end::Stepper */}
      </div>
      {/* End: Modal body */}
    </Modal>,
    modalsRoot
  )
}

export default AddNewNewProperty
